import { Divider } from "@mui/material";
import { Box } from "@mui/material";
import { RichTextInput } from "ra-input-rich-text";
import React from "react";
import { validateDateRange, validateOptionalUrl } from "../../../constants";
import {
  DateField,
  EditProps,
  Edit,
  TabbedShowLayout,
  TextField,
  TextInput,
  useEditController,
  SimpleForm,
  BooleanInput,
  ArrayField,
  SingleFieldList,
  ChipField,
  Datagrid,
  RichTextField,
  DateInput,
  useGetList,
  SelectInput,
} from "react-admin";

export const EditUser: React.FC<EditProps> = (props) => {
  const { record = {} } = useEditController();

  const { data: educationLevels = [], isLoading: isLoadingEducationLevels } = useGetList("education-levels", {
    pagination: { page: 1, perPage: 100 },
  });

  const title = record.fullName || "";
  return (
    <Edit {...props} title={title}>
      <TabbedShowLayout spacing={2} divider={<Divider flexItem />}>
        <TabbedShowLayout.Tab label="Información Personal">
          <TextField source="email" label="Correo Electrónico" />
          <SimpleForm>
            <TextInput source="fullName" label="Nombre completo" fullWidth />
            {record.role !== "ADMIN" && (
              <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
                <TextInput source="applicantProfile.gender" label="Género" />
                <TextInput source="applicantProfile.phone" label="Teléfono" />
                <TextInput
                  source="applicantProfile.linkedInProfile"
                  label="LinkedIn"
                  validate={validateOptionalUrl}
                />
              </Box>
            )}
            {record.role !== "ADMIN" && (
              <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
                <TextInput
                  source="applicantProfile.address1"
                  label="Dirección 1"
                  fullWidth
                />
                <TextInput
                  source="applicantProfile.address2"
                  label="Dirección 2"
                />
              </Box>
            )}
          </SimpleForm>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab
          label="Historial Laboral"
          disabled={record.role === "ADMIN"}
        >
          <SimpleForm>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
              <TextInput
                source="applicantProfile.workExperience.position"
                label="Puesto de Trabajo"
                fullWidth
              />
              <TextInput
                source="applicantProfile.workExperience.company"
                label="Compañía"
                fullWidth
              />
            </Box>
            <RichTextInput
              source="applicantProfile.workExperience.description"
              label="Descripción del Trabajo"
              fullWidth
            />
            <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
              <DateInput
                source="applicantProfile.workExperience.startDate"
                label="Fecha de Inicio"
                validate={(value, allValues) =>
                  validateDateRange(value, allValues?.applicantProfile?.workExperience?.endDate)
                }
              />
              <DateInput
                source="applicantProfile.workExperience.endDate"
                label="Fecha de Fin"
                validate={(value, allValues) =>
                  validateDateRange(allValues?.applicantProfile?.workExperience?.startDate, value)
                }
              />
            </Box>
            <RichTextInput
              source="applicantProfile.workExperience.internalComments"
              label="Comentarios Internos"
              fullWidth={true}
            />
          </SimpleForm>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab
          label="Intereses"
          disabled={record.role === "ADMIN"}
        >
          <ArrayField source="applicantProfile.interests" label="Intereses">
            <SingleFieldList>
              <ChipField source="name" />
            </SingleFieldList>
          </ArrayField>
          <SimpleForm>
            <BooleanInput
              source="applicantProfile.receiveEmails"
              label="Recibir Correos Electrónicos"
              defaultValue={false}
            />
          </SimpleForm>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab
          label="Idiomas"
          disabled={record.role === "ADMIN"}
        >
          <ArrayField source="applicantProfile.languages" label="Idiomas">
            <Datagrid bulkActionButtons={false}>
              <TextField source="name" label="Idioma" />
              <TextField source="level" label="Nivel" />
              <RichTextField source="comments" label="Comentarios" />
            </Datagrid>
          </ArrayField>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab
          label="Educación"
          disabled={record.role === "ADMIN"}
        >
          <SimpleForm>
            <SelectInput
              source="applicantProfile.education.degreeLevelId"
              choices={educationLevels}
              label="Nivel de Educación"
              required
            ></SelectInput>

            <RichTextInput
              source="applicantProfile.education.title"
              label="Título"
            />
            <TextInput
              source="applicantProfile.education.institution"
              label="Institución"
            />
            <DateInput
              source="applicantProfile.education.dateObtained"
              label="Fecha de Obtención"
            />
            <RichTextInput
              source="applicantProfile.education.comments"
              label="Comentarios"
            />
          </SimpleForm>
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Auditoría">
          <DateField source="createdAt" label="Creado En" />
          <DateField source="updatedAt" label="Actualizado En" />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Edit>
  );
};
